<template>
  <button class="btn btn-link mx-auto" v-on="$listeners" v-bind="$attrs">
    <span class="slot"><slot></slot></span>
    <span class="primary-fill-svg arrow">
      <inline-svg :src="require('@/assets/chevron-down.svg')" alt="Arrow Down" />
    </span>
  </button>
</template>
<script>
export default {
  name: 'ChevronDownButton',
};
</script>
<style scoped lang="scss">
@import 'src/assets/scss/variables';
button {
  position: relative;
  display: block;
  color: $primary;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 0 20px;
}
.arrow,
.slot {
  display: block;
  svg {
    width: 14px;
    height: 14px;
  }
}
</style>
